/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CompanyJobSlotJobService {

    /**
     * Update company job slot job
     * @returns any Success
     * @throws ApiError
     */
    public static updateCompanyJobSlotJob({
        companyJobSlotJobId,
        requestBody,
    }: {
        /**
         * Company Job Slot Job Id
         */
        companyJobSlotJobId: number,
        requestBody: {
            adjustment: number;
            weight?: number;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/jobdata/slotJob/{companyJobSlotJobId}',
            path: {
                'companyJobSlotJobId': companyJobSlotJobId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
